import { Calendar } from "@algomusinc/domain";
import moment from "moment";
import { EnvironmentService } from "../service/service.module";
export const CreateTimeframeListWithWeeks = (
  calendarListDropdown: any,
  timeframeList: any,
  selectable: boolean,
  expanded: boolean=true,
) => {
  const env = EnvironmentService.environment;
  calendarListDropdown = [];
  const isLeafSelectable= !expanded ? true : selectable;
  const uniqueYears: any[] = [
    ...new Set(timeframeList.map((item: Calendar) => item.fy)),
  ]; // ['FY18']
  uniqueYears.forEach((year: string, index): any => {
    const yearList = timeframeList.filter((row: any) => row.fy === year);
    const uniqueHalfYears: any[] = [
      ...new Set(yearList.map((item: Calendar) => item.hy)),
    ]; // ['H1']
    const uniqueQuarters: any[] = [];
    const uniquemonths: any[] = [];
    yearList.forEach((y: any) => {
      if (
        uniqueQuarters.findIndex(
          (x) => x.quarter === y.quarter && x.hy === y.hy
        ) < 0
      ) {
        uniqueQuarters.push({ quarter: y.quarter, hy: y.hy });
      }
      if (
        uniquemonths.findIndex(
          (x) => x.quarter === y.quarter && x.month === y.month
        ) < 0
      ) {
        uniquemonths.push({ quarter: y.quarter, month: y.month });
      }
    });
    // const uniqueQuarters = yearList.filter(year => year.quarter)
    const obj = {
      label: year,
      data: year,
      icon: '',
      leaf: false,
      expanded: expanded,
      type: '',
      partialSelected: false,
      styleClass: '',
      draggable: false,
      droppable: false,
      selectable: selectable,
      key: year,
      isRoot: true,
      children: uniqueHalfYears.map(
        (h: string) =>
          ({
            label: h,
            data: h,
            icon: '',
            leaf: false,
            expanded: expanded,
            type: '',
            partialSelected: false,
            styleClass: '',
            draggable: false,
            droppable: false,
            selectable: selectable,
            key: h,
            children: uniqueQuarters
              .filter((e) => e.hy === h)
              .map(
                (q) => ({
                    label: q.quarter,
                    data: q.quarter,
                    icon: '',
                    leaf: false,
                    expanded: expanded,
                    type: '',
                    partialSelected: false,
                    styleClass: '',
                    draggable: false,
                    droppable: false,
                    selectable: selectable,
                    key: q.quarter,
                    children: uniquemonths
                      .filter((el) => el.quarter === q.quarter)
                      .map((m) => ({
                        label: m.month,
                        data: m.month,
                        icon: '',
                        leaf: false,
                        expanded: expanded,
                        type: '',
                        partialSelected: false,
                        styleClass: '',
                        draggable: false,
                        droppable: false,
                        selectable: selectable,
                        key: m.month,
                        children: yearList.filter((el: any) =>
                            el.month === m.month &&
                            el.quarter === q.quarter &&
                            el.hy === h).map(
                          (row: any) =>({
                            label: moment.utc(row.weekStartDate).format(env.DATE_FORMAT),
                            data: row.calendarId,
                            icon: '',
                            leaf: true,
                            expanded: expanded,
                            type: '',
                            partialSelected: false,
                            styleClass: '',
                            draggable: false,
                            droppable: false,
                            key: row.calendarId,
                            selectable: isLeafSelectable
                            })
                        ),
                      })),
                  })
              ),
          })
      ),
    };
    calendarListDropdown.push(obj);
  });
  return calendarListDropdown;
};
